class SearchForm extends HTMLElement {
  constructor() {
    super();
    // Verwijder de zoekfunctionaliteit door de input en reset-knop niet te gebruiken
  }
}

// Verwijder het custom element definitie als je de zoekfunctionaliteit niet meer wilt gebruiken
customElements.define('search-form', SearchForm);
